import { useEffect, useState, useRef } from 'react'
import {
  TypographyElement,
  neutral,
  Icon,
  Icons,
  Paper
} from 'UI'
import classNames from 'classnames'
import ShowMoreText from 'components/common/ShowMoreText'
import { createUseStyles } from 'react-jss'
import style from './style'

const useStyle = createUseStyles(style)

export default ({ isOpen = false, title, text, className, textProps, showMoreProps, margin, numberOfLetter = 200, children, titleProps }) => {
  const [open, setOpen] = useState(isOpen)
  const [showMore, setShowMore] = useState(false)
  const ref = useRef()
  const [height, setHeight] = useState(open ? ref.current?.clientHeight : 0)
  useEffect(() => { setHeight(open ? ref?.current?.clientHeight : 0) }, [showMore, open])
  const { header, body, iconClass, paper, content } = useStyle({ open, margin })
  return (
    <Paper className={classNames(paper, className)}>
      <div
        onClick={() => {
          setOpen(!open)
          setShowMore(false)
        }} className={header}
      >
        <TypographyElement
          component='p'
          variant='body1'
          fontSize='19px'
          lineHeight='24px'
          spacing='0 24px 0 0'
          color={neutral[6]}
          {...titleProps}
        >
          {title}
        </TypographyElement>
        <Icon iconName={Icons.roundedDown} style={iconClass} />
      </div>
      <div className={body} style={{ height }}>
        {
       children
         ? (
           <div className={content} ref={ref}>
             {children}
           </div>
           )
         : (
           <div className={content} ref={ref}>
             {ShowMoreText(text, numberOfLetter, textProps, showMoreProps, showMore, setShowMore)}
           </div>
           )
        }
      </div>
    </Paper>
  )
}
